var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.satisfied || _vm.alwaysShowIcon)?_c('div',{staticClass:"gate-hint"},[_c('v-icon',{attrs:{"color":_vm.satisfied ? 'white' : 'error',"size":"18"}},[_vm._v(_vm._s(_vm.icon))]),(!_vm.satisfied && !_vm.iconOnly)?_c('span',{staticClass:"gate-hint__text error--text"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }